<script>
import { required } from 'vuelidate/lib/validators'

export default {
	props: {
		fartifacts: {
			type: Object,
			required: true
		}
	},
	methods: {

	}
}
</script>

<template>
	<div>
		<div class="custom-control">
			<b>Filename:</b>&nbsp;{{ fartifacts.file_name }}
		</div> 
		<div class="custom-control">
			<b>SHA256:</b>&nbsp;{{ fartifacts.file_sha256 }}
		</div> 
		<template v-if="fartifacts.file_signature_status === 'SIGNATURE_SIGNED'">
			<feather
				type="sun"
				class="icon-dual-warning icon-xs mr-2 align-middle"
			></feather>
			<b>Signatured by:</b>&nbsp;{{ fartifacts.file_signature_vendor_name}}
		</template>
		<div class="custom-control">
			<b>Alerts:</b>&nbsp;{{ fartifacts.alert_count }}
		</div> 

		<template v-if="fartifacts.file_wildfire_verdict === 'BENIGN'">
			<feather
				type="check-circle"
				class="icon-dual-success icon-xs mr-2 align-middle"
			></feather>
		</template>
		<template v-else-if="fartifacts.file_wildfire_verdict === 'MALWARE'">
			<feather
				type="flag"
				class="icon-dual-danger icon-xs mr-2 align-middle"
			></feather>
		</template>
		<template v-else>
			<feather
				type="help-circle"
				class="icon-dual-dark icon-xs mr-2 align-middle"
			></feather>
		</template>
		<b>Wildfire Verdict:</b>&nbsp;{{ fartifacts.file_wildfire_verdict }}
		<div class="custom-control">
			<b>Incidents:</b>&nbsp;{{ fartifacts.incidents.join(', ') }}
		</div> 
	</div>
</template>

<style>
	.incident-status {
		width: 15%;
	}
	.incident-description {
		width: 35%;
	}
</style>